import React, { useCallback, useEffect, useRef, useState } from 'react';
import axios, { AxiosInstance } from 'axios';
import logo from './assets/itplogo.svg';

function PdfViewer(props: { token: string }) {
  const viewer = useRef<HTMLIFrameElement>(null);
  const loadViewer = () => {
    if (!viewer || !viewer.current?.contentDocument) {
      return;
    }

    const doc = viewer.current.contentDocument;
    (doc as any).sentinelForInit = true;

    const newScript = doc.createElement('script');
    newScript.type = 'text/javascript';
    newScript.src = '/chat/app/pdfjs_mod.js';
    doc.head.appendChild(newScript);
  };
  return (<iframe id="pdfViewer" ref={viewer} src={`/chat/app/pdfjs/web/viewer.html?file=/chat/api/doc/${props.token}/pdf`} width="100%" height="100%" style={{ border: 0 }} onLoad={e => loadViewer()} />);
}

const successRegexes = [
  /approve/i, /accept/i, /confirm/i, /yes/i, /proceed/i, /agree/i,
  /authorize/i, /sign/i, /submit/i, /continue/i, /correct/i, /verify/i,
  /ok/i, /done/i, /acknowledge/i, /understand/i, /complete/i, /consent/i,
  /proceed/i, /allow/i, /grant/i, /validate/i, /certify/i, /endorse/i,
  /execute/i, /subscribe/i, /enroll/i,
  // checkmarks
  /\u2713|\u2714|\u2705|\u2611/
];

const rejectRegexes = [
  /reject/i, /decline/i, /deny/i, /no/i, /disagree/i, /refuse/i,
  /cancel/i, /withdraw/i, /abort/i, /disapprove/i, /oppose/i,
  /rescind/i, /revoke/i, /nullify/i, /invalidate/i, /veto/i,
  /incorrect/i, /wrong/i, /mistake/i, /error/i, /stop/i,
  // cross marks
  /\u2716|\u274C|\u274E|\u2573/
];

function getClassForAction(action: string): string {
  for (const re of successRegexes) {
    if (re.test(action)) {
      return 'btn-success';
    }
  }
  for (const re of rejectRegexes) {
    if (re.test(action)) {
      return 'btn-danger';
    }
  }
  return 'btn-light';
}

function AppNav(props: { token: string, manifest: DocumentManifest, setError: (error: string) => void }) {
  const takeAction = async (action: string) => {
    // POST /chat/api/doc/{token}/action/{action}
    try {
      await axios.post(`/chat/api/doc/${encodeURIComponent(props.token)}/action/${encodeURIComponent(action)}`);
      props.setError(`${action} recorded`);
    } catch (e: any) {
      console.error(e);
      props.setError(`Error taking action: ${e?.response?.data || e.message || e.toString()}`);
    }
  }
  const savePdf = async () => {
    const viewerIframe = document.getElementById('pdfViewer') as any;
    const ifwind = viewerIframe.contentWindow;
    const data = await ifwind.getSavedContent();
    alert(data.length);
  };

  const startChat = () => {
    const widgetDiv = document.getElementById('amazon-connect-chat-widget');
    const buttonElem = widgetDiv?.getElementsByTagName('button')[0] as any;
    if (buttonElem) {
      buttonElem.click();
    }
  };

  return (
    <nav className="appnav navbar navbar-dark justify-content-between">
      <a className="navbar-brand" href="/">
        <img src={logo} alt="Logo" style={{ height: '1rem', verticalAlign: 'baseline', marginRight: '0.3rem' }} />
        In Touch DMS
      </a>

      <div className="nav-tool-block mt-0">
        <ul className="navbar-nav">
          <li className="nav-item">
            {props.manifest.actions.map((action) => (
              <button key={action} type='button' className={`btn btn-sm ml-2 my-1 ${getClassForAction(action)}`} onClick={() => takeAction(action)}>{action}</button>
            ))}
            <button type='button' className='btn btn-sm btn-light ml-2 my-1' onClick={startChat}><i className="fa fa-comments" aria-hidden="true"></i> Chat</button>
            <a href="tel:+18774647055" className='btn btn-sm btn-light ml-2 my-1'><i className="fa fa-phone" aria-hidden="true"></i> Call</a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

function NewNav(props: { setError: (error: string) => void }) {
  const startChat = () => {
    const widgetDiv = document.getElementById('amazon-connect-chat-widget');
    const buttonElem = widgetDiv?.getElementsByTagName('button')[0] as any;
    if (buttonElem) {
      buttonElem.click();
    }
  };

  useEffect(() => {
    const h = setTimeout(() => {
      if ((window as any).chatAlreadyStarted) {
        return;
      }
      (window as any).chatAlreadyStarted = true;

      const widgetDiv = document.getElementById('amazon-connect-chat-widget');
      const buttonElem = widgetDiv?.getElementsByTagName('button')[0] as any;
      if (buttonElem) {
        buttonElem.click();
      }
    }, 3000);
    return () => clearTimeout(h);
  }, []);

  return (
    <nav className="appnav navbar navbar-dark justify-content-between">
      <a className="navbar-brand" href="/">
        <img src={logo} alt="Logo" style={{ height: '1rem', verticalAlign: 'baseline', marginRight: '0.3rem' }} />
        In Touch DMS
      </a>

      <div className="nav-tool-block mt-0">
        <ul className="navbar-nav">
          <li className="nav-item">
            <button type='button' className='btn btn-sm btn-light ml-2 my-1' onClick={startChat}><i className="fa fa-comments" aria-hidden="true"></i> Chat</button>
            <a href="tel:+18774647055" className='btn btn-sm btn-light ml-2 my-1'><i className="fa fa-phone" aria-hidden="true"></i> Call</a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

function ErrorPage(props: { error: string }) {
  return (<div className='p-3'>
    <h1>{props.error}</h1>
    <p>If you need further assistance, please contact us by chat or phone at <a href="tel:+18774647055">(877) 464-7055</a></p>
  </div>);
}

function LoadingPage() {
  return (<div className='p-3'>
    <h3>Loading...</h3>
  </div>);
}

interface DocumentManifest {
  actions: string[];
  username: string;
  displayName: string;
  amazonConnect: AmazonConnectToken;
}

interface AmazonConnectToken {
  widgetID: string;
  snippetID: string;
  token?: string;
}

const defaultAmazonConnectToken: AmazonConnectToken = {
  widgetID: 'fe42bbc3-75bb-403b-adad-5a5533225b22',
  snippetID: 'QVFJREFIanUzYnhvNFBocFpzVHdoQjZmUUtOd1FaMjMxR3ZDRG9RRWNFUkFkM3dWVWdINDYycVlzYjlEbFFZakhZS1crKzBaQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNVmlBdVpCamhBdlJ6Q29XN0FnRVFnQ3NxSEd2RmxXdHgwTzJiSjBxMWRJSHZWcEdSeGcrOVBDWkhBOUJSSHplNkYrWVFHZmNNQUVCM1o0S1k6Oi9TTGpHbGlRcHBwOTByaTNKbXAzeFYvQ2VWQlFLSGp1VXRqMk02N1o2N2w2NzgrTXQyckh1d3k4R0cvbHU4SnpRcTVIUHhsd2dYaGJWOTZEeWthL2hpVlluamV4VlR4RndwN1YyZ2lBcXZyd3lQenlydklucHlHZEJ4clVmWG56VndBTTZNWUtqdk40b1ArSHJFV0UxNmFROGdDTklLRT0=',
};

function loadAmazonConnect(token: AmazonConnectToken, displayName: string | null) {
  const w = window as any;
  if (w.amazon_connect) return;

  // https://docs.aws.amazon.com/connect/latest/adminguide/supported-snippet-fields.html
  const s = document.createElement('script');
  s.src = 'https://intouch.my.connect.aws/connectwidget/static/amazon-connect-chat-interface-client.js';
  s.async = true;
  s.id = token.widgetID;
  document.getElementsByTagName('head')[0].appendChild(s);
  w.amazon_connect = w.amazon_connect || function () { (w.amazon_connect.ac = w.amazon_connect.ac || []).push(arguments) };

  w.amazon_connect('styles', {
    openChat: {
      color: 'white',
      backgroundColor: '#123456'
    },
    closeChat: {
      color: 'white',
      backgroundColor: '#123456'
    }
  });
  w.amazon_connect('styles', {
    iconType: 'CHAT_VOICE',
    openChat: { color: '#ffffff', backgroundColor: '#123456' },
    closeChat: { color: '#ffffff', backgroundColor: '#123456' },
  });
  w.amazon_connect('snippetId', token.snippetID);
  w.amazon_connect('supportedMessagingContentTypes', [ 'text/plain', 'text/markdown', 'application/vnd.amazonaws.connect.message.interactive', 'application/vnd.amazonaws.connect.message.interactive.response' ]);
  if (displayName)
  {
    w.amazon_connect('customerDisplayName', function (callback: any) {
      callback(displayName);
    });
  }
  if (token.token) {
    w.amazon_connect('authenticate', (callback: any) => callback(token.token));
  }
}

function App() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const token = urlSearchParams.get('token');
  const [manifest, setManifest] = useState<DocumentManifest | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (token) {
      axios.get(`/chat/api/doc/${token}`).then((resp) => {
        if (!resp.data) {
          setError('Sorry: this link expired');
        } else {
          setManifest(resp.data as DocumentManifest);
        }
      }, (err) => {
        console.error(err);
        setError(`Error loading document: ${err?.response?.data || err.message || err.toString()}`);
      });
    }
  }, [token]);

  useEffect(() => {
    if (token && !error) {
      if (manifest) {
        loadAmazonConnect(manifest.amazonConnect, manifest.displayName);
      }
    } else {
      loadAmazonConnect(defaultAmazonConnectToken, null);
    }
  }, [token, manifest, error]);

  /*if (token && !manifest) {
    return <ErrorPage error='Sorry: this link expired' />;
  }*/

  if (error) {
    return <ErrorPage error={error} />;
  }

  if (!token) {
    return (
      <div className="approot">
        <NewNav setError={setError} />
        <main className="appmain mainbody" style={{ lineHeight: 0 }}>
        </main>
      </div>
    );
  }

  if (!manifest) {
    return <LoadingPage />;
  }

  return (
    <div className="approot">
      <AppNav token={token} manifest={manifest} setError={setError} />
      <main className="appmain mainbody" style={{ lineHeight: 0 }}>
        <PdfViewer token={token} />
      </main>
    </div>
  );
}

export default App;
